import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass';
import Tag from '../tag';

const Tags = ({ tags, ...otherProps }) => (
  <Flex
    wrap
    {...otherProps}
  >
    {tags.map(tag => (
      <Box
        key={tag}
        pr={2}
        pb={2}
      >
        <Tag title={tag} />
      </Box>
    ))}
  </Flex>
);

Tags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
};

Tags.defaultProps = {
  tags: [],
};

export default Tags;



// WEBPACK FOOTER //
// ./src/app/components/tags/index.js